import { useTranslation } from 'react-i18next';
import { buildMapEmbedUrl, formatLaundryAddress } from '@/lib/laundryProfile';
import type { LaundryAddress } from '@/types';

interface AddressMapCardProps {
  address: LaundryAddress;
  title?: string;
  className?: string;
}

/** Address line + a Google Maps embed iframe for that address. */
export default function AddressMapCard({ address, title, className }: AddressMapCardProps) {
  const { t } = useTranslation();
  const text = formatLaundryAddress(address);

  return (
    <div className={className}>
      <p className="mb-2 flex items-start gap-2 text-sm text-foreground-700">
        <i className="ri-map-pin-2-line mt-0.5 text-base text-primary-600" aria-hidden="true" />
        {text || t('settings.address.notSet')}
      </p>
      <div className="h-48 w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <iframe
          title={title ?? text}
          src={buildMapEmbedUrl(address)}
          className="h-full w-full"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}